import { Configuration } from '@azure/msal-browser'

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID ?? '',
    authority: process.env.REACT_APP_MSAL_AUTHORITY ?? '',
    redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI ?? '',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
}

export const loginRequest = {
  scopes: ['User.Read'],
  prompt: 'select_account',
}
